// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2FpYB","label":"SetPasswdForm_label__2dCRi"};